import React from 'react'
import styled from 'styled-components'
import Select from 'react-select'
import { Link, withRouter } from 'react-router-dom'

const customColors = {
  black: '#000',
  white: '#fff',
  freshGreen: '#0BAC5D',
}

// 12px	= 0.84vw = 0.8rem
// 14px	= 0.98vw = 0.9rem
// 15px	= 1vw = 0.9rem
// 16px	= 1.12vw = 1rem
// 18px	= 1.25vw = 1.1rem
// 20px	= 1.39vw = 1.3rem
// 23px = 1.59vw = 1.4rem
// 24px	= 1.67vw = 1.5rem
// 25px	= 1.73vw = 1.56rem
// 26px	= 1.81vw = 1.63rem
// 28px	= 1.95vw = 1.8rem
// 32px	= 2.22vw = 2rem
// 36px	= 2.5vw = 2rem
// 40px	= 2.78vw = 3rem
// 44px	= 3vw = 3rem
// 48px	= 3.34vw = 3rem
// 50px	= 3.47vw = 3rem

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => props.gap && `gap: ${props.gap}`};
  /* flex-wrap: wrap; */

  > div {
    width: 50%;
  }

  @media only screen and (max-width: 980px) {
    flex-wrap: wrap;

    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 980px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }
`

export const Title = styled.h1`
  color: ${(props) => (props.white ? '#fff' : '#000')};
  ${(props) => props.color && `color: ${props.color}`};
  font-family: 'Open Sans', sans-serif !important;
  font-size: ${(props) => (props.size ? props.size : '50px')};
  font-style: normal;
  font-weight: ${(props) => (props.weight ? props.weight : '700')};
  line-height: 140%;
  ${(props) => props.center && 'text-align: center'};
  ${(props) => props.margin && `margin: ${props.margin}`};

  ${(props) => props.width && `width: ${props.width}`};
  b {
    font-weight: 700;
    color: #0bac5d;
  }

  @media screen and (max-width: 1280px) {
    font-size: ${(props) => (props.sizemd ? props.sizemd : '50px')};
    ${(props) => props.marginmd && `margin: ${props.marginmd}`};
    ${(props) => props.widthMd && `width: ${props.widthMd}`};
    ${(props) => props.centerMd && 'text-align: center'};
  }

  @media screen and (max-width: 767px) {
    font-size: ${(props) => (props.sizesm ? props.sizesm : '42px')};
    ${(props) => props.marginsm && `margin: ${props.marginsm}`};
    ${(props) => props.smCenter && 'text-align: center; width: 100%;'}
    ${(props) => props.width && `width: 100%`};
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }
`

export const Subtitle = styled.h2`
  color: ${(props) => (props.white ? '#fff' : '#000')};
  ${(props) => props.color && `color: ${props.color}`};
  font-family: 'Source Sans Pro', sans-serif;
  font-size: ${(props) => (props.size ? props.size : '20px')};
  font-weight: ${(props) => (props.bold ? 'bold' : '400')};
  line-height: 146%;
  ${(props) => props.width && `width: ${props.width}`};
  ${(props) => props.center && 'text-align: center'};
  ${(props) => props.margin && `margin: ${props.margin}`};

  @media screen and (max-width: 1280px) {
    ${(props) => props.sizemd && `font-size: ${props.sizemd}`};
    ${(props) => props.marginmd && `margin: ${props.marginmd}`};
  }

  @media screen and (max-width: 767px) {
    ${(props) =>
      props.sizesm ? `font-size: ${props.sizesm}` : 'font-size: 18px'};
    ${(props) => props.marginsm && `margin: ${props.marginsm}`};
    ${(props) => props.smCenter && 'text-align: center'}
    ${(props) => props.width && `width: 100%`};
  }

  a {
    text-decoration: none;
    font-weight: ${(props) => (props.bold ? 'bold' : '400')};
    color: #000;

    &:hover {
      color: ${customColors.freshGreen};
    }
  }
`

export const CustomSubtitle = styled(Subtitle)`
  ${(props) => props.mediumBold && 'font-weight: 600'};
  b {
    font-weight: 700;

    b {
      font-weight: 700;
      color: ${customColors.freshGreen};
    }
  }

  a {
    color: ${customColors.freshGreen};
    text-decoration: none;
    font-weight: 700;
  }
`

export const Button = styled.button`
  border-radius: 5px;
  background: ${(props) => (props.background ? props.background : '#0BAC5D')};
  color: #fff;
  font-family: 'Source Sans Pro', sans-serif !important;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 170%;
  border: none;

  /*
    commented out by PJ : 
    padding: ${(props) => (props.wider ? '11px 50px' : '11px 25px')};
    a {
        text-decoration: none;
        color: #fff;
    }
    */

  padding: 0;

  a {
    display: inline-block;
    color: #fff;
    text-decoration: none;
    height: 50px;
    vertical-align: middle;
    width: 100%;
    padding: ${(props) => (props.wider ? '9px 50px' : '9px 25px')};
  }

  @media screen and (max-width: 768px) {
    ${(props) => !props.noFill && `width: -webkit-fill-available;`};
  }
`
